module.exports = __webpack_public_path__ + "img/salesclerkCancel.9d536415.png";